// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import LucideController from "./lucide_controller"
application.register("lucide", LucideController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)
